/**
 * Import node modules.
 */
// npm install smoothscroll-polyfill --save
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

/**
 * Require other JS libraries.
 */
const $ = require('jquery');
const WebFont = require('webfontloader');
const lazysizes = require('./libs/lazysizes-5.3.1.js');
const jpInView = require('./libs/jpInView.js');
const AOS = require('./libs/aos.js');
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");

Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, jQuery);

require('./libs/slick.js');



/*
// https://github.com/typekit/webfontloader

WebFont.load({
	// GOOGLE FONTS
	// google: {
	// 	families: [
	// 		'Barlow Condensed:300,400,500,600,700'
	// 	]
	// },
	// TYPEKIT
	// typekit: { id: 'abc123' },
	// CALLBACK FOR WHEN FONTS LOAD (OPTIONAL)
	// active: dje_fonts_active_cb
});

// Callback function for when the fonts are loaded.
function dje_fonts_active_cb() {

}
*/



// Use lazysizes to get lazy loading on css background images.
document.addEventListener('lazybeforeunveil', function (e) {
	try {
		var bg = e.target.getAttribute('data-bg');
    if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
    }

	} catch (error) {
		console.log('Error with lazyload background:');
		console.log(error);
	}

});


jQuery(window).on('load', function() {
	let cardsCarousel = jQuery('.carousel--cards .carousel-slides').flickity({
		pageDots: false,
		prevNextButtons: false,
		cellAlign: "left",
		contain: true,
	});
	AOS.refresh();
})

jQuery(function () {
	initTabToggle(".tabs-layout__tab-title", ".tabs-layout__tab-content");
	initTabToggle(".tab-content__subtab-title", ".tab-content__subtab-content");
	initTabAccordion();
	setTimeout(initLocationMatchHeight, 1500);

	initCollapsible();

  	jQuery('.map-embed').each(function(){
		initMap(jQuery(this));
	});

	navSubmenu();
	smoothScroll();

	if(jQuery('.dev-listing').length){
		if(jQuery('.hero__visual').length){
			jQuery('.hero__visual').css('max-height', 700);
		}
	}

	// START slick carousel custom handling
	jQuery('.carousel-slides').not('.carousel--cards .carousel-slides').each(function(i, elem){
		const isInteractive = jQuery(elem).hasClass('carousel-slides--interactive');

		jQuery(elem).slick({
			infinite: false,
			slidesToShow:  1.2,
			dots: isInteractive,
			centerMode: true,
			responsive: [
				{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false,
					draggable: !isInteractive
				},
				},
				{
					breakpoint: 576,
					settings: {
					slidesToShow: 0.85,
					slidesToScroll: 1
					},
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
					},
				}
			]
		});

		// using slick afterChange event to update pagination number
		jQuery(elem).on('afterChange', function(event, slick, currentSlide){
			const currentText = (currentSlide+1).toString();

			const header = jQuery(event.currentTarget).parent().prev();
			let currentSlideSpan = header.find('.num_current_slide');
			currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");

		});

		// for interactive carousels, show only the current slide's title & summary
		function showCurrentInteractive(){
			const current =  jQuery(elem).find('.slick-current');
			const currentTitle = current.text();
			const currentId = currentTitle.split(" ").join("").trim();
			const isMobile = window.innerWidth < 992;
			jQuery('[id*="textwrapper_"]').hide();
			jQuery(`[id*="textwrapper_${currentId}"]`).fadeIn(isMobile ? 0 : 1000);
		}

		if(isInteractive) {

			// on initial load
			showCurrentInteractive();

			// on cycle through items
			jQuery(elem).on('afterChange', function(event, slick, currentSlide){
				showCurrentInteractive();
			});
		}
	});

	// show interactive carousel popup content for current slide item
	jQuery('#int_carousel_open').on("click", function(e){
		e.preventDefault();

		// new - check if in a slider, default to zero
		var slide = 0;
		if (jQuery(this).parent().next().slick('slickCurrentSlide')) {
			slide = jQuery(this).parent().next().slick('slickCurrentSlide');
		}
		// new end

		jQuery(".carousel-modal")
			.show()
			.css({top: 'initial', opacity: 'initial'});

		jQuery('.carousel-modal__wrapper').slick({
			vertical: true,
			draggable: false,
			adaptiveHeight: true,
			nextArrow: jQuery('.carousel-modal__body-next button')
		});
		jQuery('.carousel-modal__wrapper').slick('slickGoTo', slide);
		getNextTitle();
	});

	function getNextTitle(){
		const nextTitle = jQuery('.carousel-modal .slick-current').next().find('.carousel-modal__header-title').text();
		jQuery('.carousel-modal__body-next h2').text(nextTitle);
	}

	jQuery('.carousel-modal__wrapper').on('afterChange', function(){
		getNextTitle();
	});

	jQuery(document).on("click", '.carousel-modal__header-close', function(e){

		jQuery(".carousel-modal")
			.css({top: 0, opacity:1})
			.animate({top: 500, opacity: 0}, 'slow')
			.hide(500);

		jQuery('.carousel-modal__wrapper').slick('unslick');
	});

	jQuery('.gallery-slides').each(function(i, elem){
		jQuery(elem).slick({
			infinite: false,
			slidesToShow: 1.2,
			centerMode: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
					slidesToShow: 1.25
					}
				},
				{
					breakpoint: 768,
					settings: {
					slidesToShow: 0.85
					}
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 0.85,
					slidesToScroll: 1
					},
				}
			]
		});

		// using slick afterChange event to update pagination number
		jQuery(elem).on('afterChange', function(event, slick, currentSlide){
			const currentText = (currentSlide+1).toString();

			const header = jQuery(event.currentTarget).parent().prev();
			let currentSlideSpan = header.find('.num_current_slide');
			currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");

		});
	});

	jQuery('.full-width-visual__images-carousel').each(function(i, elem) {
		jQuery(elem).slick({
			infinite: false,
			slidesToShow: 1,
			prevArrow: false,
			nextArrow: false
		})
	})

	jQuery('.wysiwyg-content table').each(function() {
		jQuery(this).wrap('<div class="wysiwyg-parent--table">')
	})

	if(jQuery('.profile-listing__carousel').length){
		jQuery('[id*="single_focus_"]').hide();
		const firstItem = jQuery('[id*="single_focus_"]')[0];
		jQuery(`#${firstItem.id}`).show();
	}

	jQuery('.profile-listing__carousel').each(function(i, elem) {
		jQuery(elem).slick({
			slidesToShow: 3,
			initialSlide: 1,
			prevArrow: `<i class="far fa-long-arrow-left slick-prev" aria-hidden="true"></i>`,
			nextArrow: `<i class="far fa-long-arrow-right slick-next" aria-hidden="true"></i>`,
			responsive: [
				{
					breakpoint: 768,
					settings: {
					slidesToShow: 2,
					slidesToScroll: 2
					}
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 2,
					slidesToScroll: 2
					},
				}
			]
		})

		jQuery(elem).on('afterChange', function(event, slick, currentSlide){
			const currentSlide = jQuery(elem).find('.slick-current');
			const previousSlide = jQuery(currentSlide).prev();
			const prevContent = jQuery(previousSlide).find('.col-4');
			let { id } = prevContent[0];

			if(id){
				id = id.replace("profile_listitem_", "");
			} else {
				// for infinite carousels in slick, duplicate slides/dup slide children don't have ids
				// so need to grab the unique id off of the title
				let prevTitle = jQuery(prevContent).find('.profile-listing__carousel-item-title').text();
				id = prevTitle.replace(/[^\w\s]/g, '');
				id = id.replaceAll(" ", "").trim();
			}

			jQuery('[id*="single_focus_"]').hide();
			jQuery(`#single_focus_${id}`).fadeIn();

		});
	})




	jQuery('.profile-listing-cards__carousel').each(function(i, elem) {
		jQuery(elem)
			.slick({
				slidesToShow: 4.5,
				slidesToScroll: 1,
				infinite: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
						slidesToShow: 3.5,
						slidesToScroll: 1
						}
					},
					{
						breakpoint: 992,
						settings: {
						slidesToShow: 1.25,
						slidesToScroll: 1
						}
					},
					{
						breakpoint: 450,
						settings: {
						centerMode: false,
						slidesToShow: 1,
						slidesToScroll: 1
						},
					}
				]
			})
			.on('afterChange', function(event, slick, currentSlide){
				const currentText = (currentSlide+1).toString();
				const header = jQuery(event.currentTarget).prev();
				let currentSlideSpan = header.find('.num_current_slide');

				currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");
			});
	});

	jQuery('.profile-listing-wquotes__carousel').each(function(i, elem) {
		jQuery(elem).slick({
			slidesToShow: 1.25,
			centerMode: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						centerMode: false
					}
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
					},
				}
			]
		})

		// using slick afterChange event to update pagination number
		jQuery(elem).on('afterChange', function(event, slick, currentSlide){
			const currentText = (currentSlide+1).toString();

			const header = jQuery(event.currentTarget).parent().prev();
			let currentSlideSpan = header.find('.num_current_slide');
			currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");

		});
	});

	jQuery('.dev-listing__carousel-slides').each(function(i, elem) {
		jQuery(elem).slick({
			slidesToShow: 2,
			slidesToScroll: 2,
			adaptiveHeight: true,
			infinite: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
					},
				}
			]
		})
	}).on('afterChange', function(event, slick, currentSlide){
		let currentText = (currentSlide+1).toString();
		currentText = window.innerWidth > 768 ? Math.ceil(currentText/2) : currentText;

		const header = jQuery(event.currentTarget).prev();
		let currentSlideSpan = header.find('.num_current_slide');

		currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");

	});

	jQuery('.latest-news__carousel').each(function(i, elem) {
		jQuery(elem).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			dots: true
		})
	});

	jQuery('.dev-visuals__carousel').each(function(i, elem) {
		jQuery(elem).slick({
			infinite: false,
			slidesToShow: 1,
			prevArrow: false,
			nextArrow: false
		})
	})

	jQuery('.dev-media__carousel-slides').each(function(i, elem) {
		jQuery(elem).slick({
			infinite: false,
			slidesToShow: 1.1,
			centerMode: true,
			centerPadding: '-10%',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 450,
					settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1
					},
				}
			]
		})
	}).on('afterChange', function(event, slick, currentSlide){
		const currentText = (currentSlide+1).toString();
		const header = jQuery(event.currentTarget).prev();
		let currentSlideSpan = header.find('.num_current_slide');

		currentSlideSpan.text(currentSlide !== 0 ? currentText : "1");
	});

	// END slick carousel custom handling

	function getRandomInt(max) {
	return Math.floor(Math.random() * max);
	}
	//hero animated text
	if($('.hero__animated-text__option').length){
	ranNum = getRandomInt($('.hero__animated-text__option').length);
	$('.hero__animated-text__option--option'+ranNum).show();
	}
	// END hero animated text

	// AOS init
	AOS.init({
		once: true,
		duration: 1000
	});

	// START video hero layout settings
		if(jQuery('.hero--animated').length && jQuery('#hero_vid')){
			if(jQuery('.hero__animated-section--full-view').length){
				jQuery('hero__animated-video').css('height', '100vh');
				jQuery('.hero__animated-section--full-view').css('height', '100vh');
			} else {
				jQuery('hero__animated-video').css('height', 'auto');
			}

			if(!jQuery('.hero__intro--animated').length &&
				jQuery('.hero__animated-section--full-view').length &&
				jQuery(window).scrollTop() < 200){
				jQuery(window).one('scroll', function(){
					jQuery('hero__animated-video').css({ height: window.innerWidth > 992 ? '975px' : '400px', position: 'absolute', top: 0})
					jQuery('.hero__animated-section--full-view').css('height', window.innerWidth > 992 ? '975px' : '400px')
					setTimeout(() => { //refresh after css animation is done
						jQuery('.hero__animated-section--full-view video').css('height', window.innerWidth > 992 ? 'auto' : '400px');
						AOS.refresh();
					}, 1000);
				})
			}
		}
	// END video hero layout settings

	// init development post map
		if(jQuery('.post--development').length && jQuery('.acf-map').length){
			jQuery('.acf-map').each(function(){
				initMap( jQuery(this) );
			});
		}


	//profile listing on career additional event
	jQuery('.profile-listing__carousel-item').on('click',function(){
		jQuery(this).parents('.profile-listing__carousel').find('.slick-next').click();
	})

	window.addEventListener('resize', function(e){
		AOS.refresh();
	})

  // Focuspoint
  focuspoint();

});  // end document ready function

function setNewsNavEffect(newsNav) {
	const newsNavHeader = document.querySelector('#news_bar_header');
	const siteHeaderHeight = document.querySelector('.site-header').offsetHeight;

	// only happens above lg breakpoint
	if(window.innerWidth > 992){
		// scroll down a bit and apply the transform
		if(window.scrollY > 40) {
			newsNav.style.cssText = `top: ${siteHeaderHeight}px;`;
			newsNav.classList.add("posts-listing__news-bar--scroll");
			newsNavHeader.classList.add("posts-listing__news-bar-header--scroll");
		} else {
			newsNav.style.cssText = "";
			newsNav.classList.remove("posts-listing__news-bar--scroll");
			newsNavHeader.classList.remove("posts-listing__news-bar-header--scroll");
		}
	} else {
		newsNav.style.cssText = "";
	}
}

const newsBar = document.querySelector('#top_news_bar');
if(newsBar){
	// run event on scroll
	window.addEventListener('scroll', function(e){
		setNewsNavEffect(newsBar);
	})

	// rerun event on resize
	window.addEventListener('resize', function(e){
		setNewsNavEffect(newsBar);
	})
}

/* Custom Drag Cursor */
jQuery(".carousel-slides-wrapper").on("mouseenter", function(e) {

	jQuery(this).find('.slateam_drag_cursor').addClass('slateam_drag_cursor--active');

	const cursorDrag = document.querySelector('.slateam_drag_cursor--active');
	if (cursorDrag){

		const moveCursor = (e)=> {
			const mouseY = e.clientY;
			const mouseX = e.clientX;

			cursorDrag.style.top = mouseY + "px";
			cursorDrag.style.left = mouseX + "px";

		}

		window.addEventListener('mousemove', moveCursor);
	}
});

jQuery(".carousel-slides-wrapper").on("mousemove", function(e){
	if(jQuery(e.target).is('a')) {
		jQuery('.slateam_drag_cursor').hide();
	}else{
		jQuery('.slateam_drag_cursor').show();
	}
});


// START toggle desktop nav search form events

jQuery('#search_icon_desktop').on("click", function(e) {
	jQuery('.nav-wrapper__socials').addClass('--open-search');

	jQuery('.nav-wrapper__social').hide();
	jQuery('#nav_items_desktop').hide();
	jQuery('.site-header__login-link').hide();
	jQuery('#search_icon_desktop').hide();
	jQuery('.nav-wrapper__end-align-box-socials').hide();
	jQuery('#search_form_desktop').removeClass('hidden');
	jQuery('#search_open_desktop').removeClass('hidden');
	jQuery('#sf_desktop_input').trigger('focus');
})

jQuery('#search_open_desktop').on("click", function(e) {
	jQuery('.nav-wrapper__socials').removeClass('--open-search');

	jQuery('.nav-wrapper__social').show();
	jQuery('#nav_items_desktop').show();
	jQuery('.site-header__login-link').show();
	jQuery('#search_icon_desktop').show();
	jQuery('.nav-wrapper__end-align-box-socials').show();
	jQuery('#search_form_desktop').addClass('hidden');
	jQuery('#search_open_desktop').addClass('hidden');
})

// END toggle desktop nav search form events

// START desktop scroll effect for main nav
jQuery(window).on('scroll', function(e){
  jQuery('.menu-item-has-child').removeClass('open');
	// only happens above lg breakpoint
	if(window.innerWidth > 992){
		// scroll down a bit and apply the transform
		if(window.scrollY > 40) {
      jQuery('#site_header').addClass('sticky');
		} else {
      jQuery('#site_header').removeClass('sticky');
		}
	}
})

// wipe inline styles on mobile resize
jQuery(window).on('resize', function(){
	if(window.innerWidth < 992){
    jQuery('#site_header').removeClass('sticky');
		/*jQuery('#site_header_logo').css('height', '')
		jQuery('#site_header').css('padding', '');
		jQuery('#nav_items_desktop').css('padding-left', '');*/
		jQuery('#search_form_mobile').removeClass('hidden');
	}else{
    if(window.scrollY > 40) {
      jQuery('#site_header').addClass('sticky');
    } else {
      jQuery('#site_header').removeClass('sticky');
    }
  }
})

// END desktop scroll effect for main nav

if(window.innerWidth < 992) jQuery('#search_form_mobile').removeClass('hidden');

// START mobile nav open/close
	jQuery('#search_icon_mobile').on('click', function(e) {
		const mainNavHeight = jQuery('#site_header').outerHeight();
		jQuery('#search_icon_mobile').hide();
		jQuery('#search_open_mobile').removeClass('hidden');
		jQuery('#nav_items_mobile').css({
			'top': `${mainNavHeight}px`,
			'height': `calc(100% - ${mainNavHeight}px)`,
			'right': '0px'
		});
		jQuery('body').css('overflow', 'hidden');
	})

	jQuery('#search_open_mobile').on('click', function(e) {
		jQuery('#search_icon_mobile').show();
		jQuery('#search_open_mobile').addClass('hidden');
		jQuery('#nav_items_mobile').css('right', `-${jQuery('#nav_items_mobile').width()}px`);
		jQuery('body').css('overflow', '');
	})
// END mobile nav open/close

// START tabs content handling

function initTabToggle(titleEl, contentEl) {
	jQuery('.tab-content__image .focuspoint').adjustFocus();
	jQuery(".tab-content__image img").on("load", function () {
		var that = this;
		jQuery(this).parents("focuspoint").adjustFocus();
		setTimeout(function () {
			console.log(jQuery(that));
			jQuery(that).css("max-width", "100%");
		}, 300);
	});

	jQuery(titleEl).on("click", function (e) {
		// grab active tab and match to content
		//get correct data parent
		let parent = jQuery(this).attr("data-parent");
		let activeTab = jQuery(`${titleEl}.active[data-parent="${parent}"]`);
		let activeContentTarget = activeTab.attr("data-tab-num");

		// Find selected Tab
		let newContentTarget = jQuery(this).attr("data-tab-num");
		jQuery(this).toggleClass("active");

		// Hide currently active tab
		activeTab.toggleClass("active");

		jQuery(`.tabs-layout__tab-content[data-tab-num="${activeContentTarget}"]`).removeClass("active");
		jQuery(`.tabs-layout__tab-content[data-tab-num="${newContentTarget}"]`).addClass("active");

		jQuery(`${contentEl}[data-tab-num="${activeContentTarget}"]`).fadeOut(150, "linear", function() {
			jQuery(`${contentEl}[data-tab-num="${newContentTarget}"]`).fadeIn(150, "linear");
		});

		// Adjust focuspoint
		jQuery('.focuspoint').adjustFocus();
		jQuery(".tab-content__image img").on("load", function () {
			jQuery(this).parents("focuspoint").adjustFocus();
			jQuery(this).css("max-width", "100%");
		});
	});
}

// END tabs content handling

// START mobile accordion handling for subtabs

function initTabAccordion() {
	const allPanels = jQuery('.mobile-subtabs__accordion > .mobile-subtab__content').hide();
	jQuery('.tab-content__image .focuspoint').adjustFocus();

	jQuery('.mobile-subtabs__accordion > .mobile-subtab__title > h6').on("click", function() {
		if(jQuery(this).parent().hasClass("active")){
			allPanels.slideUp();
			jQuery(this).parent().removeClass("active");
		} else {

		let currentActive = jQuery(this).parent().parent().find(".mobile-subtab__title.active");

			jQuery(currentActive).removeClass("active");
			allPanels.slideUp();
			jQuery(this).parent().next().slideDown();
			jQuery(this).parent().addClass("active");
		}

		// Adjust focuspoint
		jQuery('.focuspoint').adjustFocus();
		jQuery(".tab-content__image img").on("load", function () {
			jQuery(this).parents("focuspoint").adjustFocus();
		});

		return false;
	});
}

// END mobile accordion handling for subtabs

// START Location Listing dynamic video height
function initLocationMatchHeight(){
	if(window.innerWidth > 767){
	var divHeight = jQuery('.location-listing__left-grid').height();
	jQuery('.location-listing__video-wrapper').css('height', divHeight+'px');
	}
}
// END Location Listing dynamic video height

// START collapsible handling
function initCollapsible(){

	jQuery(".collapsible__button").on("click", function (e) {
		e.preventDefault();

		var target = jQuery(this).attr('href');

		if (jQuery(this).hasClass("collapsible__button--active")) {

			jQuery(this)
				.removeClass("collapsible__button--active")
				.attr("aria-expanded", "false");
			jQuery(this)
				.closest(".collapsible-content__content")
				.removeClass("active");
			jQuery(this)
				.find(".fa-minus")
				.addClass("hidden");
			jQuery(this)
				.find(".fa-plus")
				.removeClass("hidden");
			jQuery(target)
				.slideUp()
				.attr("aria-hidden", "true");
		} else {
			jQuery(this)
				.addClass("collapsible__button--active")
				.attr("aria-expanded", "true");
			jQuery(this)
				.closest(".collapsible-content__content")
				.addClass("active");
			jQuery(this)
				.find(".fa-plus")
				.addClass("hidden");
			jQuery(this)
				.find(".fa-minus")
				.removeClass("hidden");
			jQuery(target)
				.slideDown()
				.attr("aria-hidden", "false");
		}

	});
}

// END collapsible handling


// shorthand for document ready

/// Map-related Functions ///
function initMap($mapElement){
  const zoom = parseInt($mapElement.attr('data-zoom'));
  // Find marker elements within map.
  var $markers = $mapElement.find('.marker');

  const map = new google.maps.Map($mapElement[0], {
    zoom: zoom,
    mapTypeControl: false,
    scaleControl: false,
    fullscreenControl : false,
    maxZoom: 17,
    styles:
    [
		{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#e9e9e9"
				},
				{
					"lightness": 17
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f5f5f5"
				},
				{
					"lightness": 20
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#ffffff"
				},
				{
					"lightness": 17
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#ffffff"
				},
				{
					"lightness": 29
				},
				{
					"weight": 0.2
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffffff"
				},
				{
					"lightness": 18
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffffff"
				},
				{
					"lightness": 16
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f5f5f5"
				},
				{
					"lightness": 21
				}
			]
		},
		{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#dedede"
				},
				{
					"lightness": 21
				}
			]
		},
		{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"visibility": "on"
				},
				{
					"color": "#ffffff"
				},
				{
					"lightness": 16
				}
			]
		},
		{
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"saturation": 36
				},
				{
					"color": "#333333"
				},
				{
					"lightness": 40
				}
			]
		},
		{
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#f2f2f2"
				},
				{
					"lightness": 19
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#fefefe"
				},
				{
					"lightness": 20
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#fefefe"
				},
				{
					"lightness": 17
				},
				{
					"weight": 1.2
				}
			]
		}
	]
  });

	// Add marker
	map.markers = [];
	$markers.each(function(){
		// Get position from marker.
		var lat = jQuery(this).attr('data-lat');
		var lng = jQuery(this).attr('data-lng');
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		const marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon: '/wp-content/themes/slateam/assets/images/marker-development.png'
		});

		map.markers.push(marker);
	});

  centerMap(map);

}

function centerMap( map ) {

  // Create map boundaries from all map markers.
  var bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function( marker ){
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng()
    });
  });

  // Case: Single marker.
  if( map.markers.length == 1 ){
    map.setCenter( bounds.getCenter() );

  // Case: Multiple markers.
  } else{
    map.fitBounds( bounds );
  }

  reAdjustMarkerOnResize(map);
}

function reAdjustMarkerOnResize(map) {
	jQuery(window).on("resize", function() {
		google.maps.event.trigger(map, 'resize');
	}).trigger("resize");
  }


function navSubmenu(){
	jQuery('.site-header .menu-item-has-children').on("click",function(e){
	  e.preventDefault();
	  jQuery(this).toggleClass('open');
	})
	jQuery('.site-header .sub-menu .menu-item a').on("click",function(e){
	  e.stopPropagation();
	  jQuery(this).closest('.menu-item-has-children').toggleClass('open');
	})
}

/// JS from contractor for location listing ///
function locationListingClick() {
	let displayBlocks = document.querySelectorAll(".display-block");
	let displayControls = document.querySelectorAll(".u-control");
	if (displayBlocks && displayControls) {

		document.addEventListener('click', (event) => {
			let control = event.target.closest('.u-control');
			if (control) {
				displayControls.forEach((item, index) => {
					if (item === control) {
						item.classList.add('u-active');
					} else {
						item.classList.remove('u-active');
					}
				}); // end displayControls for each
				displayBlocks.forEach((item, index) => {
					if (index == control.classList[1]) {
						item.classList.add('u-display');

					} else {
						item.classList.remove('u-display');
					}
				}); // end displayBlocks for each
			} // end if target
		}); // end click event

	} // end if display var generate

}

locationListingClick();

const images = document.querySelectorAll('.u-image');
const videos = document.querySelectorAll('.u-video');
if(images && videos){
	function replaceElements() {
		if (window.matchMedia('(max-width: 767px)').matches) {
		  videos.forEach((video, index) => {
		   video.replaceWith(images[index]);
		  });
		}
	  }

	  window.addEventListener('load', replaceElements);
	  replaceElements();
}

const smoothScroll = () => {
	// Scrolling for anchor links in within the same page
  jQuery('a[href*="#"]:not([href="#"])').click(function(){
      _hash = this.hash;
      _scroll_it( _hash );
  });

  // scrolling for anchor links coming from a different page
  var _hash = window.location.hash;
  if( _hash.length > 0 ){
      window.scrollTo(0, 0);

      setTimeout( function() {
          _scroll_it( _hash );
      }, 500 );
  }
};

function _scroll_it( _hash ){
	if(jQuery(window).outerWidth() > 767){
		jQuery('html,body').animate({
			scrollTop: jQuery( _hash ).offset().top - 75
		}, 500 );
	}else{
		jQuery('html,body').animate({
			scrollTop: jQuery( _hash ).offset().top
		}, 500 );
	}
}

// - - - Focus point on images - - -
function focuspoint() {
  setTimeout(function () {
    jQuery('.focuspoint').focusPoint({
      throttleDuration: 100, // Refresh rate
      reCalcOnWindowResize: true
    });
  }, 500);
};
